// extracted by mini-css-extract-plugin
export default {"button":"createNamespacePopup_button__h+bDj","input":"createNamespacePopup_input__HHNna","globalErrors":"createNamespacePopup_globalErrors__MTP1l"};